module.exports = __webpack_public_path__ + "img/gamma3_bg.f503314c.png";